/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Plan_Best_LabelInputs */

const et_plan_best_label = /** @type {(inputs: Plan_Best_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kvartal (3 kuud)`)
};

const en_plan_best_label = /** @type {(inputs: Plan_Best_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Quarterly (3 months)`)
};

/**
* | output |
* | --- |
* | "Quarterly (3 months)" |
*
* @param {Plan_Best_LabelInputs} inputs
* @param {{ locale?: "et" | "en" }} options
* @returns {LocalizedString}
*/
export const plan_best_label = /** @type {((inputs?: Plan_Best_LabelInputs, options?: { locale?: "et" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Plan_Best_LabelInputs, { locale?: "et" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "et") return et_plan_best_label(inputs)
	return en_plan_best_label(inputs)
});